import React, { useState, useEffect, useCallback } from 'react';
import Service from './service';
import UserService from '../../../User/service';
import TrunkService from '../../../Trunk/service';
import ExtensionService from '../../../Extension/service';
import { useGetQueues } from 'views/Report/hooks/useGetQueues';

import { useForm, Controller, useWatch } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { toast } from 'react-toastify';
import SimpleHeader from 'components/Headers/SimpleHeader.js';
import FlexSelect from 'components/Inputs/FlexSelect';
import Pagination from 'components/Pagination';
import Loader from 'react-loader-spinner';
import HourMaskMMHHSS from '../../../../components/Inputs/HourMaskMMHHSS.js';
import DatePicker from '../../../../components/Inputs/DatePicker.js';
import ReportAnalythical from './tables/Analytical';
import ReportSynthetical from './tables/Synthetic';
import { definedMessageGeneratedInPdfCsvDownloads } from '../../utils/definedMessageGeneratePdfCsv';
import { disabledDownloadButtonCsvAndPdf } from '../../utils/disabledDownloadButtonCsvAndPdf';
import ReportDetailedSynthetic from './tables/DetailedSynthetic';
import { reportOptions, statusCall, daysOfWeek } from '../utils/types';
import { dateRules, hourRules } from '../utils/rulesValidation';
import pdfImage from '../../../../assets/img/pdf.png';
import csvImage from '../../../../assets/img/csv.png';
import xlsxImage from '../../../../assets/img/xlsx.png';
import * as fileSaver from 'file-saver';
import { v4 as uuid } from 'uuid';
import { format, startOfMonth } from 'date-fns';
import { Tooltip } from '@material-ui/core';
import { useSelector } from 'react-redux';

import {
  Container,
  Row,
  Card,
  Form,
  Col,
  CardHeader,
  Button,
  CardBody,
  Input
} from 'reactstrap';

import {
  ImageButtonContainer,
  ImageButton,
  ImageSize
} from '../../../../assets/styles/image_style';
import { reports } from 'http';
import { buttonStyle } from 'components/Containers/ConfigurationContainer/components/utils';
import { useGetTeamsFiltered } from 'hooks/useGetTeamsFiltered';
import { UserFlexSelect } from '../../../../components/UserFlexSelect';
import { ItemPerPageSelect } from 'components/Inputs/ItemPerPageSelect';

const CallMadeReport = () => {
  const { control, handleSubmit, errors, setValue, watch, getValues } =
    useForm();
  const systemConfiguration = useSelector((state) => state.systemConfiguration);
  const [ReportTypeAnalytical, setReportTypeAnalytical] = useState([]);
  const [ReportTypeSynthetical, setReportTypeSynthetical] = useState([]);
  const [ReportTypeDetailedSynthetic, setReportTypeDetailedSynthetic] =
    useState([]);
  const [dataToSubmitDownloads, setDataToSubmitDownloads] = useState();
  const [usersShowDisable, setUsersShowDisable] = useState(true);
  const [agents, setAgents] = useState([]);
  const [trunks, setTrunks] = useState([]);
  const [extensions, setExtensions] = useState([]);
  const [loadingForm, setLoadingForm] = useState(false);
  const [loadingTable, setLoadingTable] = useState(false);
  const reportType = watch('reportType');
  const [itemPerPage, setItemsPerPage] = useState(10);

  const showDisableQueueAndExtension = !!useWatch({ control, name: 'disable' });
  const { queues } = useGetQueues(showDisableQueueAndExtension, setLoadingForm);

  const [activePage, setActivePage] = useState(1);
  const [quantity, setQuantity] = useState(0);
  const [extraDataFromAnalyticalReport, setExtraDataFromAnalyticalReport] =
    useState();
  const [chartDataList, setCharDataList] = useState([]);
  const [listCallForHourDto, setlistCallForHourDto] = useState([]);
  const limitGenerationPDF = parseInt(
    process.env.REACT_APP_LIMIT_GENERATION_PDF || 25000
  );
  const [messagemGeneratePdf, setMessagemGeneratePdf] = useState();
  const [messagemGenerateCsv, setMessagemGenerateCsv] = useState();
  const [messagemGenerateXlsx, setMessagemGenerateXlsx] = useState();
  const { teams } = useGetTeamsFiltered();

  //trunk to select
  useEffect(() => {
    getTrunk();
  }, []);

  useEffect(() => {
    getUser(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usersShowDisable]);

  const getTrunk = () => {
    TrunkService.getAll()
      .then((response) => {
        setTrunks(response.data.data);
      })
      .catch((err) => {
        console.log('err: ' + err);
      });
  };

  const getUser = (showDisable = false) => {
    if (!showDisable) {
      setLoadingForm(true);
    }
    UserService.getAll(false, undefined, undefined, usersShowDisable)
      .then((response) => {
        setAgents(response.data.data);
        if (!showDisable) {
          setLoadingForm(false);
        }
      })
      .catch((err) => {
        console.log('err: ' + err);
        if (!showDisable) {
          setLoadingForm(false);
        }
      });
  };

  //show extensions enabled and disabled for select
  useEffect(() => {
    ExtensionService.getAllShowDisableNew(showDisableQueueAndExtension)
      .then((response) => {
        setExtensions(response.data.data);
      })
      .catch((err) => {
        console.log('err: ' + err);
      });
  }, [showDisableQueueAndExtension]);

  useEffect(() => {
    //data clear for analytical report
    if (reportType === 1) {
      setQuantity(0);
      setActivePage(1);
      setReportTypeSynthetical([]);
      setReportTypeDetailedSynthetic([]);
    }
    //data clear for synthetic report
    if (reportType === 2) {
      setQuantity(0);
      setActivePage(1);
      setReportTypeAnalytical([]);
      setCharDataList([]);
      setlistCallForHourDto([]);
      setReportTypeDetailedSynthetic([]);
    }
    //data clear for detailedSynthetic
    if (reports === 3) {
      setQuantity(0);
      setActivePage(1);
      setReportTypeAnalytical([]);
      setReportTypeSynthetical([]);
    }
  }, [reportType]);

  useEffect(() => {
    const message = definedMessageGeneratedInPdfCsvDownloads(
      quantity,
      limitGenerationPDF
    );

    setMessagemGeneratePdf(message.pdfMessage);
    setMessagemGenerateCsv(message.csvMessage);
    setMessagemGenerateXlsx(message.messagemGenerateXlsx);
  }, [quantity, limitGenerationPDF]);

  const downloadMedia = useCallback(
    async (media, type, fileName) => {
      if (media === 'pdf' || media === 'csv') {
        try {
          let typeReport;
          if (dataToSubmitDownloads.reportType === 1) typeReport = 'analytical';
          if (dataToSubmitDownloads.reportType === 2) typeReport = 'synthetic';
          if (dataToSubmitDownloads.reportType === 3)
            typeReport = 'detailedsynthetic';
          //type, page, format, queryParams
          const response = await Service.getDownloads(
            typeReport,
            1,
            media,
            dataToSubmitDownloads
          );
          fileSaver.saveAs(new Blob([response.data], { type }), fileName);
        } catch (err) {
          console.log('erro', err);
          toast.error(
            'Ops, ocorreu um erro. Por favor, entre em contato com o suporte',
            {
              autoClose: 3000,
              closeOnClick: true
            }
          );
        }
      } else if (media === 'xlsx') {
        try {
          const response = await Service.getDownloadCallOutXlsx(
            dataToSubmitDownloads
          );
          fileSaver.saveAs(new Blob([response.data], { type }), fileName);
        } catch (err) {
          toast.error(
            'Ops, ocorreu um erro. Por favor, entre em contato com o suporte',
            {
              autoClose: 3000,
              closeOnClick: true
            }
          );
        }
      }
    },
    [dataToSubmitDownloads]
  );

  const toISOFormat = useCallback(async (dateTimeString, bar = false) => {
    const [date] = dateTimeString.split(' ');
    const [DD, MM, YYYY] = date.split('/');
    if (bar) return `${MM}/${DD}/${YYYY}`;
    return `${MM}-${DD}-${YYYY}`;
  }, []);

  const getDataDTO = useCallback(
    async (data) => {
      let dataToSend;
      dataToSend = {
        ...data,
        dateBegin: `${await toISOFormat(data.dateBegin)} ${data.timeStart}`,
        dateEnd: `${await toISOFormat(data.dateEnd)} ${data.timeEnd}`,
        timeStart: data.timeStart.replace(/:/g, ''),
        timeEnd: data.timeEnd.replace(/:/g, '')
      };

      if (dataToSend.queue.length > 0)
        dataToSend = { ...dataToSend, queue: dataToSend.queue.join(',') };
      else delete dataToSend.queue;

      if (!dataToSend.daysOfWeek) delete dataToSend.daysOfWeek;

      if (dataToSend.groupbyTeam)
        if (dataToSend.groupbyTeam.length > 0)
          dataToSend = {
            ...dataToSend,
            groupbyTeam: dataToSend.groupbyTeam.join(',')
          };
        else delete dataToSend.groupbyTeam;

      if (dataToSend.groupby) {
        if (dataToSend.groupby.length > 0)
          dataToSend = {
            ...dataToSend,
            groupby: dataToSend.groupby.join(',')
          };
        else delete dataToSend.groupby;
      } else delete dataToSend.groupby;

      if (dataToSend.agent.length !== 0) {
        dataToSend.agent = dataToSend.agent.join(',') || null;
      }

      agents &&
        agents.find((user) => {
          if (user.agent_code === dataToSend.agent) {
            dataToSend.agentName = user.name;
          }
        });

      if (!dataToSend.agentName) delete dataToSend.agentName;
      if (!dataToSend.agent) delete dataToSend.agent;
      if (!dataToSend.carrier) delete dataToSend.carrier;
      if (!dataToSend.disposition) delete dataToSend.disposition;
      if (!dataToSend.dst) delete dataToSend.dst;
      if (!dataToSend.origin) delete dataToSend.origin;
      if (reportType !== 3) {
        delete dataToSend.groupby;
      }
      setDataToSubmitDownloads(dataToSend);
      return dataToSend;
    },
    [toISOFormat, reportType]
  );

  const defineTypeReport = async (type) => {
    if (type === 1) {
      return 'analytical';
    }
    if (type === 2) {
      return 'synthetic';
    }
    if (type === 3) {
      return 'detailedsynthetic';
    }
  };

  const getReports = useCallback(
    (typeReport, selectedPage = 1, dataToSend) => {
      //definir tipo = analytical, synthetic,pdf, excel, detailedsynthetic
      const newActivePage = selectedPage || activePage;
      if (typeReport === 'analytical') {
        setLoadingTable(true);

        Service.getAllReportsType(
          typeReport,
          selectedPage,
          dataToSend,
          itemPerPage
        )
          .then((res) => {
            const {
              listCallAnalytical,
              quantity,
              quantityCallAnswer,
              quantityCallNoAnswer,
              waitingServiceTimeFormated,
              averageServiceTimeFormated
            } = res.data.data;
            listCallAnalytical.forEach((el, index) => {
              listCallAnalytical[index].uuid = uuid();
            });
            setReportTypeAnalytical(listCallAnalytical);
            setQuantity(quantity);
            setExtraDataFromAnalyticalReport({
              quantityCallAnswer: quantityCallAnswer,
              quantityCallNoAnswer: quantityCallNoAnswer,
              waitingServiceTimeFormated: waitingServiceTimeFormated,
              averageServiceTimeFormated: averageServiceTimeFormated
            });
            setActivePage(newActivePage);
            if (listCallAnalytical.length === 0) {
              toast.info('Nenhum registro foi encontrado!');
            }
            setLoadingTable(false);
          })
          .catch((err) => {
            setLoadingTable(false);
            console.log('err' + err);
          });
      }

      if (typeReport === 'synthetic') {
        setLoadingTable(true);

        Service.getAllReportsType(typeReport, selectedPage, dataToSend)
          .then((res) => {
            const { listQuantityCallForQueueDto, list, listCallForHourDto } =
              res.data.data;

            listQuantityCallForQueueDto.forEach((el, index) => {
              listQuantityCallForQueueDto[index].uuid = uuid();
            });
            setReportTypeSynthetical(listQuantityCallForQueueDto);
            setQuantity(listQuantityCallForQueueDto.length);
            setActivePage(newActivePage);
            setCharDataList(list);
            setlistCallForHourDto(listCallForHourDto);
            if (listQuantityCallForQueueDto.length === 0) {
              toast.info('Nenhum registro foi encontrado!');
            }

            setLoadingTable(false);
          })
          .catch((err) => {
            setLoadingTable(false);
            console.log(err);
          });
      }

      if (typeReport === 'detailedsynthetic') {
        setLoadingTable(true);
        Service.getAllReportsType(typeReport, selectedPage, dataToSend)
          .then((res) => {
            const { listCallDetailedSyntheticCallCenterDTO, quantity } =
              res.data.data;
            listCallDetailedSyntheticCallCenterDTO.forEach((el, index) => {
              listCallDetailedSyntheticCallCenterDTO[index].uuid = uuid();
            });
            setReportTypeDetailedSynthetic(
              listCallDetailedSyntheticCallCenterDTO
            );
            setQuantity(quantity);
            setActivePage(newActivePage);
            if (listCallDetailedSyntheticCallCenterDTO.length === 0) {
              toast.info('Nenhum registro foi encontrado!');
            }
            setLoadingTable(false);
          })
          .catch((err) => {
            setLoadingTable(false);
            console.log('err' + err);
          });
      }
    },
    [activePage, itemPerPage]
  );

  const onSubmit = useCallback(
    async (data) => {
      try {
        const dataToSend = await getDataDTO(data);
        const typeReport = await defineTypeReport(reportType);
        getReports(typeReport, 1, dataToSend);
      } catch (err) {
        toast.error(err || 'Erro desconhecido por favor, informar o suporte!', {
          autoClose: 3000,
          closeOnClick: true
        });
      }
    },
    [getDataDTO, reportType, getReports]
  );

  const errorFormMessage = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );

  const handlePageChange = (activePage) => {
    let reportType = null;
    if (dataToSubmitDownloads.reportType === 1) reportType = 'analytical';
    if (dataToSubmitDownloads.reportType === 2) reportType = 'synthetic';
    if (dataToSubmitDownloads.reportType === 3)
      reportType = 'detailedsynthetic';
    getReports(reportType, activePage, dataToSubmitDownloads);
  };

  const getDateBegin = () => {
    const date = new Date();
    const firstDayMonth = new Date(
      date.getFullYear('pt-br'),
      date.getMonth('pt-br'),
      1
    );
    const dateBegin = format(startOfMonth(firstDayMonth), 'dd/LL/yyyy');
    return dateBegin;
  };

  return (
    <>
      <SimpleHeader
        name="Form validation"
        parentName="Forms"
        showBackArrow="not"
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3>Relatório Chamadas Realizadas Callcenter</h3>
                </CardHeader>
                <CardBody>
                  {loadingForm ? (
                    <Row className="justify-content-md-center">
                      <Loader
                        type="TailSpin"
                        color={systemConfiguration.primary_color}
                        height={100}
                        width={100}
                      />
                    </Row>
                  ) : (
                    <>
                      <Form
                        className="needs-validation"
                        onSubmit={handleSubmit(onSubmit)}
                      >
                        <Row className="mb-3">
                          <Col md="6">
                            <label className="form-control-label">
                              Operadora
                            </label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  dataOptions={trunks}
                                  isMulti={false}
                                  value={props.value}
                                  valueController={setValue}
                                  closeMenuOnSelect={true}
                                  fieldName="carrier"
                                  labelName="name"
                                  valueName="id"
                                />
                              )}
                              control={control}
                              name="carrier"
                              defaultValue=""
                            />
                          </Col>
                          <Col md="6">
                            <label className="form-control-label">Agente</label>

                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  dataOptions={agents}
                                  isMulti={true}
                                  value={props.value}
                                  valueController={setValue}
                                  isClearable={true}
                                  closeMenuOnSelect={false}
                                  fieldName="agent"
                                  labelName="name"
                                  valueName="agent_code"
                                />
                              )}
                              control={control}
                              name="agent"
                              defaultValue=""
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md="6">
                            <label className="form-control-label">Origem</label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  dataOptions={extensions}
                                  isMulti={false}
                                  value={props.value}
                                  valueController={setValue}
                                  isClearable={true}
                                  closeMenuOnSelect={true}
                                  fieldName="origin"
                                  labelName="extension_number"
                                  valueName="extension_number"
                                />
                              )}
                              control={control}
                              name="origin"
                              defaultValue=""
                            />
                          </Col>
                          <Col md="6">
                            <label className="form-control-label">
                              Destino
                            </label>

                            <Controller
                              as={Input}
                              control={control}
                              name="dst"
                              defaultValue=""
                            />
                            <ErrorMessage
                              errors={errors}
                              name="dst"
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col md="6">
                            <label className="form-control-label">
                              Data inicial*
                            </label>
                            <Controller
                              render={(props) => (
                                <DatePicker
                                  fieldName="dateBegin"
                                  valueController={setValue}
                                  defaultValue={props.value}
                                />
                              )}
                              control={control}
                              name="dateBegin"
                              rules={dateRules}
                              defaultValue={getDateBegin()}
                            />
                            <ErrorMessage
                              errors={errors}
                              name="dateBegin"
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </Col>

                          <Col md="6">
                            <label className="form-control-label">
                              Hora inicial*
                            </label>
                            <Controller
                              render={(props) => (
                                <HourMaskMMHHSS
                                  valueController={setValue}
                                  fieldName="timeStart"
                                  value={props.value}
                                />
                              )}
                              control={control}
                              name="timeStart"
                              rules={hourRules}
                              defaultValue="00:00:00"
                            />
                            <ErrorMessage
                              errors={errors}
                              name="timeStart"
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col md="6">
                            <label className="form-control-label">
                              Data final*
                            </label>
                            <Controller
                              render={(props) => (
                                <DatePicker
                                  fieldName="dateEnd"
                                  valueController={setValue}
                                  defaultValue={props.value}
                                />
                              )}
                              control={control}
                              name="dateEnd"
                              defaultValue={new Date().toLocaleDateString(
                                'pt-br'
                              )}
                              rules={{
                                ...dateRules,
                                validate: async (value) => {
                                  if (
                                    new Date(await toISOFormat(value, true)) <
                                    new Date(
                                      await toISOFormat(
                                        getValues()['dateBegin'],
                                        true
                                      )
                                    )
                                  ) {
                                    return 'A data final não pode ser anterior à inicial!';
                                  } else {
                                    return true;
                                  }
                                }
                              }}
                            />
                            <ErrorMessage
                              errors={errors}
                              name="dateEnd"
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </Col>

                          <Col md="6">
                            <label className="form-control-label">
                              Hora final*
                            </label>
                            <Controller
                              render={(props) => (
                                <HourMaskMMHHSS
                                  valueController={setValue}
                                  fieldName="timeEnd"
                                  value={props.value}
                                />
                              )}
                              control={control}
                              name="timeEnd"
                              rules={hourRules}
                              defaultValue="23:59:59"
                            />
                            <ErrorMessage
                              errors={errors}
                              name="timeEnd"
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md="6">
                            <label className="form-control-label">
                              Status da chamada
                            </label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  dataOptions={statusCall}
                                  isMulti={false}
                                  value={props.value}
                                  valueController={setValue}
                                  closeMenuOnSelect={true}
                                  fieldName="disposition"
                                  labelName="label"
                                  valueName="value"
                                />
                              )}
                              control={control}
                              name="disposition"
                              defaultValue=""
                            />
                          </Col>
                          <Col md="6">
                            <label className="form-control-label">
                              Fila(s)
                            </label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  dataOptions={queues}
                                  isMulti={true}
                                  isClearable={true}
                                  value={props.value}
                                  closeMenuOnSelect={false}
                                  valueController={setValue}
                                  fieldName="queue"
                                  labelName="name"
                                  valueName="id"
                                />
                              )}
                              control={control}
                              name="queue"
                              defaultValue=""
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col md="6">
                            <label className="form-control-label">Equipe</label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  isClearable={true}
                                  dataOptions={teams}
                                  isMulti={false}
                                  closeMenuOnSelect={true}
                                  value={props.value}
                                  valueController={setValue}
                                  fieldName="teamId"
                                  labelName="name"
                                  valueName="id"
                                />
                              )}
                              control={control}
                              name="teamId"
                              defaultValue=""
                            />
                            <ErrorMessage
                              errors={errors}
                              name="teamId"
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </Col>
                          <Col md="6">
                            <label className="form-control-label">
                              Dia da semana
                            </label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  dataOptions={daysOfWeek}
                                  isMulti={false}
                                  value={props.value}
                                  valueController={setValue}
                                  closeMenuOnSelect={true}
                                  isClearable={true}
                                  fieldName="daysOfWeek"
                                  labelName="label"
                                  valueName="value"
                                />
                              )}
                              control={control}
                              name="daysOfWeek"
                              defaultValue=""
                            />
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col md="6">
                            <label className="form-control-label">
                              Tipo de Relatório
                            </label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  dataOptions={reportOptions}
                                  isMulti={false}
                                  value={props.value}
                                  valueController={setValue}
                                  closeMenuOnSelect={true}
                                  fieldName="reportType"
                                  labelName="label"
                                  valueName="value"
                                />
                              )}
                              control={control}
                              name="reportType"
                              defaultValue={1}
                            />
                          </Col>
                        </Row>

                        <Row className="mb-12">
                          <Col className="md-6 mx-4">
                            <div style={{ display: 'flex', gap: '20px' }}>
                              <Controller
                                name="disable"
                                control={control}
                                render={(props) => (
                                  <>
                                    <label className="form-control-label">
                                      <Input
                                        type="checkbox"
                                        onChange={(e) =>
                                          props.onChange(e.target.checked)
                                        }
                                        checked={props.value}
                                      />
                                      Mostrar desabilitados (Ramal, Fila)
                                    </label>
                                  </>
                                )}
                                defaultValue=""
                              />
                              <UserFlexSelect
                                usersShowDisable={usersShowDisable}
                                setUsersShowDisable={setUsersShowDisable}
                                name={'Agentes'}
                              />
                            </div>
                          </Col>
                          <Col md="4" style={ImageButtonContainer}>
                            <div id="button_pdf">
                              {reportType !== 1 && (
                                <button
                                  style={ImageButton}
                                  name="pdf"
                                  onClick={() =>
                                    downloadMedia(
                                      'pdf',
                                      'application/pdf',
                                      'Relatório_de_Chamada_Realizada.pdf'
                                    )
                                  }
                                  disabled={disabledDownloadButtonCsvAndPdf(
                                    'pdf',
                                    quantity,
                                    limitGenerationPDF
                                  )}
                                >
                                  <Tooltip
                                    title={
                                      <p style={{ fontSize: '14px' }}>
                                        {messagemGeneratePdf}
                                      </p>
                                    }
                                    arrow
                                  >
                                    <img
                                      src={pdfImage}
                                      alt="pdf"
                                      style={ImageSize}
                                    />
                                  </Tooltip>
                                </button>
                              )}
                            </div>

                            <button
                              id="button_csv"
                              style={ImageButton}
                              onClick={() =>
                                downloadMedia(
                                  'csv',
                                  'application/csv',
                                  'Relatório_de_Chamada_Realizada.csv'
                                )
                              }
                              disabled={disabledDownloadButtonCsvAndPdf(
                                'csv',
                                quantity,
                                limitGenerationPDF
                              )}
                            >
                              <Tooltip
                                title={
                                  <p style={{ fontSize: '14px' }}>
                                    {messagemGenerateCsv}
                                  </p>
                                }
                                arrow
                              >
                                <img
                                  src={csvImage}
                                  alt="csv"
                                  style={ImageSize}
                                />
                              </Tooltip>
                            </button>
                            {reportType === 1 && (
                              <button
                                style={ImageButton}
                                name="xlsx"
                                onClick={() =>
                                  downloadMedia(
                                    'xlsx',
                                    'application/octet-stream',
                                    'Relatório_de_Chamada_Realizada.xlsx'
                                  )
                                }
                                disabled={disabledDownloadButtonCsvAndPdf(
                                  'xlsx',
                                  quantity,
                                  limitGenerationPDF
                                )}
                              >
                                <Tooltip
                                  title={
                                    <p style={{ fontSize: '14px' }}>
                                      {messagemGenerateXlsx}
                                    </p>
                                  }
                                  arrow
                                >
                                  <img
                                    src={xlsxImage}
                                    alt="xlsx"
                                    style={ImageSize}
                                  />
                                </Tooltip>
                              </button>
                            )}
                          </Col>
                        </Row>

                        <Button
                          style={buttonStyle(systemConfiguration.primary_color)}
                          type="submit"
                        >
                          Buscar
                        </Button>
                        <Row className="mb-3">
                          <Col
                            md="3"
                            style={{ marginTop: '-45px', marginLeft: '110px' }}
                          >
                            <ItemPerPageSelect
                              valueController={setItemsPerPage}
                            ></ItemPerPageSelect>
                          </Col>
                        </Row>
                      </Form>
                    </>
                  )}
                </CardBody>
                {loadingTable ? (
                  <div className="py-4 table-responsive">
                    <Row className="justify-content-md-center">
                      {loadingTable && (
                        <Loader
                          type="TailSpin"
                          color={systemConfiguration.primary_color}
                          height={100}
                          width={100}
                        />
                      )}
                    </Row>
                  </div>
                ) : (
                  <>
                    {reportType === 1 && dataToSubmitDownloads && (
                      <ReportAnalythical
                        showReports={ReportTypeAnalytical}
                        quantity={quantity}
                        extraDataFromAnalyticalReport={
                          extraDataFromAnalyticalReport
                        }
                      />
                    )}
                    {reportType === 2 && dataToSubmitDownloads && (
                      <ReportSynthetical
                        showReports={ReportTypeSynthetical}
                        list={chartDataList}
                        listCallForHourDto={listCallForHourDto}
                        typeReport={dataToSubmitDownloads.reportType}
                      />
                    )}
                    {reportType === 3 && dataToSubmitDownloads && (
                      <ReportDetailedSynthetic
                        dataToSend={dataToSubmitDownloads}
                        showReports={ReportTypeDetailedSynthetic}
                        totalRegister={quantity}
                      />
                    )}
                    {dataToSubmitDownloads && (
                      <Pagination
                        itemsCountPerPage={itemPerPage}
                        activePage={activePage}
                        totalItemsCount={quantity}
                        onChange={handlePageChange.bind(this)}
                      />
                    )}
                  </>
                )}
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default CallMadeReport;
